import React from 'react';
import { Link } from 'react-router-dom';
import { BUSINESS } from '@/lib/site';

export default function Logo({ variant = 'light', compact = false }) {
  const isDark = variant === 'dark';
  const wordmarkColor = isDark ? '#fff' : '#060D9C';
  const subColor = isDark ? 'rgba(255,255,255,0.7)' : 'rgba(6,13,156,0.62)';

  return (
    <Link
      to="/"
      className="flex items-center gap-3 group"
      data-testid="site-logo"
      aria-label={`${BUSINESS.name} home`}
    >
      <div
        className="shrink-0 overflow-hidden"
        style={{ width: compact ? 44 : 56, height: compact ? 44 : 56 }}
      >
        <img
          src="/generated/logo.png"
          alt="NFT logo"
          className="h-full w-full object-contain"
        />
      </div>
      {!compact && (
        <div className="leading-none">
          <div
            className="font-display font-extrabold uppercase"
            style={{ color: wordmarkColor, letterSpacing: '-0.01em', fontSize: '1.4rem', lineHeight: 1 }}
          >
            National Forklift
          </div>
          <div
            className="font-display font-extrabold uppercase"
            style={{ color: wordmarkColor, letterSpacing: '-0.01em', fontSize: '1.4rem', lineHeight: 1 }}
          >
            Training <span style={{ color: '#FC4E2C' }}>Ltd</span>
          </div>
          <div className="label-eyebrow mt-1" style={{ color: subColor, fontSize: '0.62rem' }}>
            Est. 1990 · WorkSafeNZ Approved
          </div>
        </div>
      )}
      {compact && (
        <div className="leading-none">
          <div className="font-display font-extrabold uppercase text-2xl" style={{ color: wordmarkColor, lineHeight: 1 }}>
            NFT
          </div>
          <div className="label-eyebrow" style={{ color: subColor, fontSize: '0.55rem' }}>
            Forklift Training
          </div>
        </div>
      )}
    </Link>
  );
}
